import { CreateGroupCommand, Group } from '@era/security-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupResolverActions = createActionGroup({
  source: 'Group Resolver',
  events: {
    'Groups requested': emptyProps(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupListUIActions = createActionGroup({
  source: 'Group List UI',
  events: {
    'Group add requested': props<{ group: CreateGroupCommand }>(),
  },
});

export const GroupListItemUIActions = createActionGroup({
  source: 'Group List Item UI',
  events: {
    'Group delete requested': props<{ group: Group }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupApiActions = createActionGroup({
  source: 'Group API',
  events: {
    'Groups loaded': props<{ groups: Group[] }>(),
    'Groups loaded error': props<{ error: ErrorModel }>(),
    'Group deleted': props<{ group: Group }>(),
    'Group deleted error': props<{ group: Group; error: ErrorModel }>(),
    'Group added': props<{ group: Group }>(),
    'Group added error': props<{ group: CreateGroupCommand; error: ErrorModel }>(),
  },
});
